import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'fancyDate'
})
export class FancyDatePipe implements PipeTransform {
  transform(value: any) {
    if (value != null && value != 0) {
      if (typeof value === 'string' || value instanceof String) {
        value = new Date(value + "");
      } else {
        if (Number.isInteger(value)) {
          value = new Date(value);
        }
      }
      value.setHours(value.getHours());
      value.setMinutes(value.getMinutes());
      return value.getDate() + "" + DateUtil.getMonthString("" + (value.getMonth() + 1)) + " " + this.withZero(value.getHours()) + ":" + this.withZero(value.getMinutes());
    } else {
      return "-";
    }
  }

  withZero(time) {
    return time > 9 ? time : "0" + time;
  }

}
